<template>
  <div>
    <section id="ci-particles">
      <canvas id="canvas" width="1080" height="1080"></canvas>
    </section>
  </div>
</template>

<script lang="js">
import { Options, Vue } from 'vue-class-component'

var particles = [],
amount = 0,
mouse = { x: -9999, y: -9999 },
radius = 1,
colors = [
  "rgba(0,215,180,0.85)", 
  "rgba(0,215,180, 0.75)", 
  "rgba(0,215,180,1)", 
  "rgba(102,204,204,1)", 
  "rgba(102,204,204,0.85)", 
  "rgba(204,204,204,1)",
  "rgba(204,204,204,0.85)",
  "rgba(204,204,204,0.75)",
],
ww = window.innerWidth,
wh = ww;

@Options({
  props: ['pvh', 'text'],
  data() {
    return {
      
    }
  },
  mounted() {
    if (this.text === 'PM2.5') {
      colors = [
        "rgba(43,190,243,0.85)", 
        "rgba(26,230,208, 0.75)", 
        "rgba(43,190,243,0.95)",
        "rgba(69,249,253,1)",
        "rgba(0,215,180,1)",
        "rgba(43,190,243,1)",
        "rgba(43,190,243,0.75)",
        "rgba(26,230,208, 0.85)",
        "rgba(69,249,253,0.85)", 
      ]
    }
    this.fn();
  },
  methods: {
    fn() {
      const _this = this;
      const pvh = this.pvh;
      var canvas = document.querySelector("#canvas"),
        ctx = canvas.getContext("2d"),
        link = document.createElement('link');

        function Particle(x, y) {
          this.x = Math.random() * ww;
          this.y = Math.random() * wh;
          this.dest = { x: x, y: y };
          this.r = Math.random() * 0.9 * Math.PI;
          this.vx = (Math.random() - 0.8) * 25;
          this.vy = (Math.random() - 0.8) * 25;
          this.accX = 0;
          this.accY = 0;
          this.friction = Math.random() * 0.025 + 0.9;
          this.color = colors[Math.floor(Math.random() * 2.75)];
        }

        Particle.prototype.render = function() {

          this.accX = (this.dest.x - this.x) / 300;
          this.accY = (this.dest.y - this.y) / 300;
          this.vx += this.accX;
          this.vy += this.accY;
          this.vx *= this.friction;
          this.vy *= this.friction;
          this.x += this.vx;
          this.y += this.vy;

          ctx.fillStyle = this.color;
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.r, Math.PI * 2, false);
          ctx.fill();

          var a = this.x - mouse.x;
          var b = this.y - mouse.y;

          var distance = Math.sqrt(a * a + b * b);
          if (distance < (radius * 175)) {

            this.accX = (this.x - mouse.x) / 100;
            this.accY = (this.y - mouse.y) / 100;
            this.vx += this.accX;
            this.vy += this.accY;
          }
        }

          function onMouseMove(e) {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
          }

          function onTouchMove(e) {
            if (e.touches.length > 0) {
              mouse.x = e.touches[0].clientX;
              mouse.y = e.touches[0].clientY;
            }
          }

        function onTouchEnd(e) {
          mouse.x = -9999;
          mouse.y = -9999;
        }

        function initScene() {

          ww = canvas.width = window.innerWidth;
          wh = canvas.height = ww;

          ctx.clearRect(0, 0, canvas.width, canvas.height);

          ctx.font = (_this.text === 'PM2.5') ? 'bold 28vw "Abril Fatface"' : 'bold 24vw "Abril Fatface"';
          ctx.textAlign = "center";
          if (_this.text === 'PM2.5') {
            ctx.fillText('PM2.5', ww / 2, wh / 2);
          } else {
            ctx.fillText('CHINA', ww / 2, wh / 2 + ((pvh * ww) || 0));
            ctx.fillText('TRAVEL', ww / 2, wh / 2 + ww * 0.25 + ((pvh * ww) || 0));
          }

          var data = ctx.getImageData(0, 0, ww, wh).data;

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = "screen";

          particles = [];
          for (var i = 0; i < ww; i += Math.round(ww / 120)) {
            for (var j = 0; j < wh; j += Math.round(ww / 90)) {
              if (data[((i + j * ww) * 4) + 3] > 60) {
                particles.push(new Particle(i, j));
              }
            }
          }
          amount = particles.length;
        }

        function render(a) {
          requestAnimationFrame(render);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          for (var i = 0; i < amount; i++) {
            particles[i].render();
          }
        }

        // window.addEventListener("mousemove", onMouseMove);
        // window.addEventListener("touchmove", onTouchMove);
        // window.addEventListener("touchend", onTouchEnd);
        initScene();
        requestAnimationFrame(render);
    },
  }
})
export default class Travel extends Vue {
  
}
</script>

<style lang="scss" scoped>
#ci-particles {
  canvas {
    width: 100%;
  }
}
</style>